const resendToken = document.getElementById('resend-token');
const counterResend = document.getElementById('counter-resend');
const countDownTimer = document.getElementById('countdown-timer');

const in1 = document.getElementById('twoStepsCode1'),
  ins = document.querySelectorAll('.otc fieldset div input[type="number"]'),
  splitNumber = function(e) {
    const data = e.data || e.target.value; // Chrome doesn't get the e.data, it's always empty, fallback to value then.
    if (!data) { return; }  // Shouldn't happen, just in case.
    if (data.length === 1) { return; }// Here is a normal behavior, not a paste action.

    popuNext(e.target, data);
  },
  popuNext = function(el, data) {
    el.value = data[0]; // Apply first item to first input
    data = data.substring(1); // remove the first char.
    if ( el.nextElementSibling && data.length ) {
      // Do the same with the next element and next data
      popuNext(el.nextElementSibling, data);
    } else {
      // When get to the last element, focus him
      el.focus();
    }
  },
  setEvents = function() {
    ins.forEach(function(input) {
      /**
       * Control on keyup to catch what the user intent to do.
       * I could have check for numeric key only here, but I didn't.
       */
      input.addEventListener('keyup', function(e){
        // Break if Shift, Tab, CMD, Option, Control.
        if (e.keyCode === 16 || e.keyCode == 9 || e.keyCode == 224 || e.keyCode == 18 || e.keyCode == 17) {
          return;
        }

        // On Backspace or left arrow, go to the previous field.
        if ( (e.keyCode === 8 || e.keyCode === 37)
          && this.previousElementSibling
          && this.previousElementSibling.tagName === 'INPUT'
        ) {
          this.previousElementSibling.focus();
        } else if (e.keyCode !== 8 && this.nextElementSibling) {
          this.nextElementSibling.focus();
        }

        // If the target is populated to quickly, value length can be > 1
        if ( e.target.value.length > 1 ) {
          splitNumber(e);
        }
      });

      /**
       * Better control on Focus
       * - don't allow focus on other field if the first one is empty
       * - don't allow focus on field if the previous one if empty (debatable)
       * - get the focus on the first empty field
       */
      input.addEventListener('focus', function(e) {
        // If the focus element is the first one, do nothing
        if ( this === in1 ) { return; }

        // If value of input 1 is empty, focus it.
        if ( in1.value == '' ) {
          in1.focus();
        }

        // If value of a previous input is empty, focus it.
        // To remove if you don't wanna force user respecting the fields order.
        if ( this.previousElementSibling.value == '' ) {
          this.previousElementSibling.focus();
        }
      });
    });
    /**
     * Handle copy/paste of a big number.
     * It catches the value pasted on the first field and spread it into the inputs.
     */
    in1.addEventListener('input', splitNumber);
    resendToken.addEventListener('click', () => countdown(true));
    countdown(false);
  };

let currentInterval;

function countdown(resendCode) {
  const otcInputs = document.querySelectorAll('.otc-input');
  const resendTokenMessage = document.querySelector('.resend-token-message');

  if (resendCode) {
    sessionStorage.removeItem('date');
    sessionStorage.removeItem('finalTime');

    resendTokenMessage.style.display = 'none';
    resendToken.style.display = 'none';

    for (let i = 0; i < otcInputs.length; i++) {
      otcInputs[i].disabled = false;
      otcInputs[i].classList.remove('otc-disabled');
    }

    const idAutenticacao = document.getElementById('idAutenticacaoTwoFactor').value;
    const idHolding = document.getElementById('idHoldingTwoFactor').value;

    $.ajax({
      method: 'GET',
      url: route('app.auth.resend-token-two-factory'),
      data: {
        'idAutenticacao': idAutenticacao,
        'idHolding': idHolding
      }
    });
  }

  const date = sessionStorage.getItem('date');
  const finalTime = sessionStorage.getItem('finalTime');
  const now = Date.now();
  let totalTime = 180;
  const timeMfa = window.time_mfa || 1200;
  let totalFinalTime = timeMfa;

  if (date) {
    const diffDate = Math.round((now - date) / 1000);
    totalTime = 180 - diffDate;
  } else {
    sessionStorage.setItem('date', now);
  }

  if (finalTime) {
    const diffFinalTime = Math.round((now - finalTime) / 1000);
    totalFinalTime = timeMfa - diffFinalTime;
  } else {
    sessionStorage.setItem('finalTime', now);
  }

  if (currentInterval && resendCode) {
    clearInterval(currentInterval);
  }
  currentInterval = startTime(totalFinalTime, resendTokenMessage, otcInputs);

  const downloadTimer = setInterval(function () {
    const minute = Math.floor(totalTime / 60);
    let seconds = totalTime % 60;

    seconds = seconds < 10 ? '0' + seconds : seconds;
    countDownTimer.textContent = minute + 'm' + seconds + 's';

    totalTime--;

    if (totalTime <= 0) {
      clearInterval(downloadTimer);

      resendToken.style.display = 'block';
      counterResend.style.display = 'none';
      countDownTimer.textContent = '';
    } else {
      counterResend.style.display = 'block';
      resendToken.style.display = 'none';
    }
  }, 1000);
}

function startTime(totalFinalTime, resendTokenMessage, otcInputs) {
  const downloadFinalTimer = setInterval(function () {
    totalFinalTime--;
    if (totalFinalTime <= 0) {
      resendTokenMessage.style.display = 'block';
      clearInterval(downloadFinalTimer);
      for (let i = 0; i < otcInputs.length; i++) {
        otcInputs[i].disabled = true;
        otcInputs[i].classList.add('otc-disabled');
      }
    } else {
      resendTokenMessage.style.display = 'none';
    }
  }, 1000);

  return downloadFinalTimer;
}

module.exports = {
  init: setEvents
}
